"use client"

import React, { useEffect, useState } from "react"
import { useContext } from "react";
import Header from "src/components/common/Header";
import { MenuContext } from "src/context/MenuContext";
import Menu from "src/components/common/Menu";
import { getYearList, setStaffWorkDetails } from "src/store/staffworkstatus";
import { useDispatch, useSelector } from "react-redux";

const StaffWorkStatus = () => {
  const dispatch = useDispatch();
  const year = useSelector(state => state.staffworkstatus?.data?.yearList) || [];
  const start_end_year = useSelector(state => state.staffworkstatus?.data?.dateParams) || {};
  const month = useSelector(state => state.staffworkstatus?.data?.monthList) || [];
  const user = useSelector(state => state.staffworkstatus?.data?.userList)
  const staff = useSelector(state => state.staffworkstatus?.data?.staffData) || {};
  const staff_work_details = useSelector(state => state.staffworkstatus?.data?.staff_work_details) || {};


  // First, define state properly
  const [start_end_yr, setStart_end_yr] = useState({
    start_year: start_end_year.start_year || new Date().getFullYear(),
    start_month: start_end_year.start_month || new Date().getMonth() + 1,
    end_year: start_end_year.end_year || new Date().getFullYear(),
    end_month: start_end_year.end_month || new Date().getMonth() + 4,
    search_user_id: start_end_year.search_user_id || "",
  });

  const [yearList, setYearList] = useState(year);
  const [monthList, setMonthList] = useState(month);
  const [userList, setUserList] = useState(user);
  const [staffData, setStaffData] = useState(staff_work_details || {});
  const [activeDateKey, setActiveDateKey] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const [searchTriggered, setSearchTriggered] = useState(false);

  useEffect(() => {
    dispatch(getYearList());
  }, []);


  useEffect(() => {
    setYearList(year);
    setMonthList(month);
    setUserList(user);
    setStaffData(staff);
  }, [year, month, user]);

  useEffect(() => {
    if (staff_work_details && Object.keys(staff_work_details).length > 0) {
      setStaffData(staff_work_details);
    }
  }, [staff_work_details]);

  useEffect(() => {
    if (start_end_year && Object.keys(start_end_year).length > 0) {
      setStart_end_yr(start_end_year);
    }
  }, []);


  useEffect(() => {
    if (initialized && start_end_year && Object.keys(start_end_year).length > 0) {
      const startMonth = parseInt(start_end_year.start_month || new Date().getMonth() + 1);
      const startYear = parseInt(start_end_year.start_year || new Date().getFullYear());

      const calculatedEndMonth = startMonth + 3;
      const endMonth = calculatedEndMonth > 12 ? calculatedEndMonth - 12 : calculatedEndMonth;
      const endYear = calculatedEndMonth > 12 ? startYear + 1 : startYear;

      const updated = {
        start_year: startYear,
        start_month: startMonth,
        end_year: parseInt(start_end_year.end_year) || endYear,
        end_month: parseInt(start_end_year.end_month) || endMonth,
        search_user_id: start_end_year.search_user_id || "",
      };

      setStart_end_yr(updated);
      dispatch(setStaffWorkDetails(updated)); // this line ensures output updates on change
    }
  }, [start_end_year]);


  useEffect(() => {
    if (!initialized && start_end_yr && start_end_yr.start_year && start_end_yr.start_month) {
      dispatch(setStaffWorkDetails(start_end_yr));
      setInitialized(true);
    }
  }, [start_end_yr, initialized]);

  useEffect(() => {
    if (searchTriggered) {
      dispatch(setStaffWorkDetails(start_end_yr));
      setSearchTriggered(false); // reset the trigger
    }
  }, [searchTriggered, start_end_yr]);


  useEffect(() => {
    const handleClickOutside = () => {
      setActiveDateKey(null); // Close any open tooltip
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);


  const handleSearch = () => {
    setSearchTriggered(true);
  };


  // Handle form clear
const handleClear = () => {
  const now = new Date();
  const end = new Date(now);
  end.setMonth(end.getMonth() + 3); // Add 3 months to current month

  setStart_end_yr({
    start_year: now.getFullYear(),
    start_month: now.getMonth() + 1,
    end_year: end.getFullYear(),
    end_month: end.getMonth() + 1,
    search_user_id: "",
  });
  setSearchTriggered(true);
};


  // Modified handleChange function
  const handleChange = (e) => {
    const { name, value } = e.target;

    setStart_end_yr(prev => {
      let newValue = value;
      // Only parse as int if not search_user_id
      if (name !== 'search_user_id' && value !== '') {
        newValue = parseInt(value, 10);
      }

      const newState = {
        ...prev,
        [name]: newValue
      };

      // Validation logic
      if (name === 'start_year') {
        if (newState.start_year > newState.end_year) {
          newState.end_year = newState.start_year;
        }
      }
      if (name === 'start_month' && newState.start_year === newState.end_year) {
        if (newState.start_month > newState.end_month) {
          newState.end_month = newState.start_month;
        }
      }

      return newState;
    });
  };


  const toggleDate = (key, event) => {
    event.stopPropagation(); // Prevents click from bubbling to document

    setActiveDateKey(prev => (prev === key ? null : key)); // toggle logic
  };




  const { visibleMenu } = useContext(MenuContext);
  return (
    <div >
      {visibleMenu && <Menu />}
      <div className={visibleMenu ? "menu-open" : "menu-closed"}>
        <div className="navbar navbar-fixed-top navbar-absolute">
          <Header sx={{ mb: 4 }} />
        </div>
        <div>
          <section className="container-fluid contents-top">

            <div className="text-center w100p">
              <h1>Staff Availability</h1>
              <form className="work_status_form" id="work_status_form" method="post">
                <div className="display_block w30p">
                  <div className="display_block">
                    <label>Period</label>
                    <select
                      name="start_year"
                      value={start_end_yr.start_year || ''}
                      onChange={handleChange}
                    >
                      {yearList.map((year) => (
                        <option key={`start-year-${year}`} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>&nbsp;
                  </div>
                  <div className="display_block">
                    <select
                      name="start_month"
                      value={start_end_yr.start_month}
                      onChange={handleChange}
                    >
                      {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                        <option
                          key={`start-month-${month}`}
                          value={month}
                        >
                          {month}
                        </option>
                      ))}
                    </select>
                  </div>
                  &nbsp;
                  <span>&nbsp;～&nbsp;</span>
                  <div className="display_block">
                    <select name="end_year" value={start_end_yr.end_year} onChange={handleChange}>
                      {yearList.map((year) => (
                        <option key={`end-year-${year}`} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>&nbsp;
                  </div>
                  <div className="display_block">
                    <select name="end_month" value={parseInt(start_end_yr.end_month)} onChange={handleChange}>
                      {monthList.map((month) => (
                        <option key={`end-month-${month}`} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="display_block w30p">
                  <label>Staff Name</label>&nbsp;
                  <select name="search_user_id" value={start_end_yr.search_user_id} onChange={handleChange}>
                    <option value="">---</option>
                    {userList.map((user) => (
                      <option key={`user-${user.id}`} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>

                  &nbsp;
                </div>
                <div style={{ padding: "10px" }}>
                  <button type="button" className="btn btn-success jq_work_status_search" onClick={handleSearch}>
                    <font style={{ verticalAlign: "inherit" }}>
                      <font style={{ verticalAlign: "inherit" }}>search</font>
                    </font>
                  </button>&nbsp;
                  <button type="button" className="btn btn-success jq_work_status_clear" onClick={handleClear}>
                    Clear
                  </button>
                </div>
              </form>
            </div>
          </section>
        </div>

        <div id="work_status" className="text-center container mb10">
          {staffData && Object.keys(staffData).length > 0 ? (
            <table className="status_table">
              <thead>
                <tr>
                  <th colSpan="4"></th>
                  {
                    (() => {
                      // Use first available staff's month_data
                      const firstDetail = staffData[0]?.staff_work_details?.[0];
                      const monthData = firstDetail?.month_data ?? [];

                      return monthData.map((monthItem, index) => (
                        <td
                          key={`month-${monthItem.month}`}
                          colSpan="1"
                          className="ac"
                          style={{
                            width: `${monthItem.td_width?.width ?? 80}px`,
                          }}
                        >
                          {monthItem.month}Month
                        </td>
                      ));
                    })()
                  }
                </tr>
              </thead>

              <tbody>
                {staffData && Object.entries(staffData).map(([key, userData],idx) => {
                  if (!userData?.staff_work_details || !Array.isArray(userData.staff_work_details)) {
                    return null;
                  }

                  const userId = userData.staff_work_details[0]?.user_id || key || idx;

                  let rowspan = 1;
                  let count = 1;
                  let prevProjectId = 0;
                  return (
                    <React.Fragment key={`staff-${userId}-${idx}`}>
                      <tr className="al">
                        <th className="pl10" colSpan={4}>
                          {userData.staff_work_details[0]?.user_name || ''}
                        </th>
                      </tr>

                      {
                        (() => {
                          const renderedProjectIds = new Set();

                          return userData.staff_work_details.map((workDetail, detailIndex) => {
                            if (!workDetail) return null;

                            const projectId = workDetail.project_id;
                            const isNewProject = projectId && !renderedProjectIds.has(projectId);

                            if (isNewProject) {
                              renderedProjectIds.add(projectId);
                            }

                            rowspan = workDetail.rowspan || 1;

                            return projectId ? (
                              <tr  key={`work-detail-${workDetail.user_id}-${workDetail.project_id}-${detailIndex}`}  className="f12">
     
                                {/* Project name cell */}
                                {isNewProject && (
                                  <td className="ac w200" rowSpan={workDetail.rowspan}>
                                    <a
                                      href={`/projectDetails/${workDetail.project_id}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {workDetail.project_name || ''}
                                      <br />
                                      {workDetail.client_name || ''}
                                    </a>
                                  </td>
                                )}

                                {/* Date range cell */}
                                <td className="ac w110">
                                  {workDetail.start_date || ''} ~ {workDetail.end_date || ''}
                                </td>

                                {/* Planned hours cell */}
                                <td className="ac w100">
                                  {workDetail.total_hr ? Math.round(workDetail.total_hr) : 0}H
                                  <br />
                                  [{workDetail.total_days ? Math.round(workDetail.total_days * 10) / 10 : 0}Person Day]
                                </td>

                                {/* Worked hours cell */}
                                {isNewProject && (
                                  <td
                                    rowSpan={workDetail.rowspan}
                                    className={`ac w100 ${workDetail.total_worked_hr > workDetail.total_hr ? "bg_pink" : ""}`}

                                  >
                                    {workDetail.total_worked_hr || 0}H
                                    <br />
                                    [{workDetail.total_worked_days || 0}Person Day]
                                  </td>
                                )}

                                {/* Placeholder for Gantt chart or details */}
                                <td
                                  colSpan={workDetail.month_data?.length || 4}
                                  className={new Date(workDetail.up_datetime) > new Date() ? "bg-lightyellow" : ""}
                                  style={{ backgroundColor: '#FFFFE0' }}
                                >
                                  <div style={{ position: 'relative' }}>
                                    {workDetail.month_data?.map((month, idx) => {
                                      // Check if work exists in this month
                                      const isWorkInMonth = (startDate, endDate) => {
                                        const start = new Date(startDate);
                                        const end = new Date(endDate);
                                        const currentMonth = month.month;
                                        const startMonth = start.getMonth() + 1;
                                        const endMonth = end.getMonth() + 1;
                                        const startYear = start_end_yr.start_year;

                                        const endYear = start_end_yr.end_year;

                                        // If same year, just check months
                                        if (startYear === endYear) {
                                          return currentMonth >= startMonth && currentMonth <= endMonth;
                                        }

                                        // If different years, check full range
                                        const monthYear = `${month.year}-${month.month}`;
                                        const startMonthYear = `${startYear}-${startMonth}`;
                                        const endMonthYear = `${endYear}-${endMonth}`;
                                        return monthYear >= startMonthYear && monthYear <= endMonthYear;
                                      };

                                      // Only show if work exists in this month
                                      if (isWorkInMonth(workDetail.start_date, workDetail.end_date)) {
                                        return (
                                          <div
                                            key={`month-${workDetail.user_id}-${workDetail.project_id}-${month.month}-${detailIndex}-${idx}`}
                                            style={{
                                              position: 'absolute',
                                              left: `${idx === 0 ? 0 : idx * 140}px`,
                                              width: `${month.td_width?.width || 100}px`,
                                              marginTop: '-10px',
                                            }}
                                          >
                                            <div
                                              className="status_color comment_popup pointer bg_blue"
                                              id="user-icon"
                                              style={{ "width": '140px', justifyContent: 'center', display: 'flex' }}
                                            >
                                              PM
                                            </div>
                                            <div style={{ position: 'relative', width: '140px' }}>

                                              {/* Maru circles container */}
                                              <div className="row-container">
                                                {workDetail?.work_dates
                                                  ?.split(',')
                                                  .filter(dateStr => dateStr.trim())
                                                  .map(dateStr => {
                                                    const date = new Date(dateStr.trim());
                                                    return !isNaN(date.getTime()) ? date : null;
                                                  })
                                                  .filter(date => {
                                                    if (!date) return false;
                                                    const targetMonth = parseInt(month.month);
                                                    const targetYear = start_end_yr.start_year;
                                                    const dateMonth = date.getMonth() + 1;
                                                    const dateYear = date.getFullYear();
                                                    return dateMonth === targetMonth && dateYear === targetYear;
                                                  })
                                                  .map((date, dateIdx) => {
                                                    const key = `${workDetail.user_id}-${workDetail.project_id}-${month.month}-${dateIdx}`;
                                                    return (
                                                      <div key={key} style={{ position: 'relative' }}>
                                                        <label
                                                          className="maru_circle"
                                                          onClick={(e) => toggleDate(key, e)}
                                                        />
                                                        <div className={`worked_date ${activeDateKey === key ? 'active' : ''}`}>
                                                          {date.toLocaleDateString('ja-JP', {
                                                            month: '2-digit',
                                                            day: '2-digit'
                                                          }).replace('/', 'Mon/') + 'Day'}
                                                        </div>
                                                      </div>
                                                    );
                                                  })}
                                              </div>

                                            </div>


                                          </div>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                </td>
                              </tr>
                            ) : null;
                          });
                        })()
                      }

                      <tr>
                        <td className="ar mr10 pr10" colSpan="4">
                          {
                            userData.staff_work_details.map((workDetail, detailIndex) => (
                              !workDetail.project_id ? (
                                <React.Fragment key={`no-project-${detailIndex}`}>
                                  <span style={{ float: "left", marginLeft: "10px" }}>
                                    ※ There are no scheduled projects
                                  </span>
                                  Planned operation total
                                </React.Fragment>
                              ) : (
                                <React.Fragment key={`project-${detailIndex}`}>
                                  Planned operation total
                                </React.Fragment>
                              )
                            ))[0]
                          }
                        </td>
                        {userData.staff_work_details[0]?.month_data?.map((month, idx) => (
                          <>
                            <td
                              key={`monthly-total-${idx}`}
                              className="ac"
                              style={{
                                width: `${month?.td_width?.width || 100}px`,
                                backgroundColor: '#DBEEF4'
                              }}
                            >
                              <span>
                                {userData.staff_work_details.some(detail => {
                                  const startDate = new Date(detail.start_date);
                                  const endDate = new Date(detail.end_date);
                                  const currentMonth = month.month;
                                  return startDate.getMonth() + 1 <= currentMonth &&
                                    endDate.getMonth() + 1 >= currentMonth &&
                                    detail.total_worked_hr;
                                }) ? (
                                  <>
                                    {/* Assumed Hours for current month */}
                                    {`Assumed :${Math.round(
                                      userData.staff_work_details.reduce((sum, detail) => {
                                        const startDate = new Date(detail.start_date);
                                        const endDate = new Date(detail.end_date);
                                        const currentMonth = month.month;
                                        if (startDate.getMonth() + 1 <= currentMonth &&
                                          endDate.getMonth() + 1 >= currentMonth) {
                                          return sum + (detail.total_hr || 0);
                                        }
                                        return sum;
                                      }, 0)
                                    )}H`}
                                    <br />
                                    {/* Actual Hours for current month */}
                                    {`(Actual ${Math.round(
                                      userData.staff_work_details.reduce((sum, detail) => {
                                        const startDate = new Date(detail.start_date);
                                        const endDate = new Date(detail.end_date);
                                        const currentMonth = month.month;
                                        if (startDate.getMonth() + 1 <= currentMonth &&
                                          endDate.getMonth() + 1 >= currentMonth) {
                                          return sum + (detail.total_worked_hr || 0);
                                        }
                                        return sum;
                                      }, 0)
                                    )}H)`}
                                  </>
                                ) : (
                                  <>
                                    {/* Only Assumed hours for current month if no actual hours */}
                                    {`${Math.round(
                                      userData.staff_work_details.reduce((sum, detail) => {
                                        const startDate = new Date(detail.start_date);
                                        const endDate = new Date(detail.end_date);
                                        const currentMonth = month.month;
                                        if (startDate.getMonth() + 1 <= currentMonth &&
                                          endDate.getMonth() + 1 >= currentMonth) {
                                          return sum + (detail.total_hr || 0);
                                        }
                                        return sum;
                                      }, 0)
                                    )}H`}
                                    <br />
                                    {`(Assumed)`}
                                  </>
                                )}
                              </span>
                            </td>
                          </>
                        ))}
                      </tr>
                    </React.Fragment>
                  );

                })}
              </tbody>


            </table>
          ) : (
            <div>No Records found</div>
          )}
        </div>

      </div>
    </div>
  )
}

export default StaffWorkStatus


